import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import mapImg from '../img/map.png';
import mapParams from '../img/map_param.png';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { fetchMeteo, fetchMeteoList } from '../strapi';
import Markdown from 'react-markdown';
import dateFormat from 'dateformat';
import img_base from '../img/image.png'


function Meteo({ locale }) {
    const API_URL = process.env.REACT_APP_STRAPI_URL;
    
    const InitMeteo = () => {
        fetchMeteo(locale)
            .then(data => {
                return data
            })
            .catch(err => {
            });
    }
    const InitMeteoList = () => {
        fetchMeteoList(locale)
            .then(data => {
                setMeteoList(data);
            })
            .catch(err => {
            });
    }
    const [meteo, setMeteo] = useState({});
    const [meteoList, setMeteoList] = useState([])
    useEffect(() => {
        const element = document.getElementById("top");
        element.scrollIntoView({ behavior: "instant", block: "start" });
        fetchMeteo(locale)
            .then(data => {
                setMeteo(data);
                //console.log(data)
            })
            .catch(err => {
            });
    }, []);
    useEffect(() => {
        fetchMeteoList(locale)
            .then(data => {
                setMeteoList(data);
            })
            .catch(err => {
            });
    }, []);


    return (
        <div >
            <Container id="top">
                <Typography className='titleOfPage' component="div" sx={{ mt: { xs: '', xl: '60px' }, pt: { xs: '80px', xl: '' } }}>
                    {meteo.title}
                </Typography>
                <Typography className='mainText' >
                    {meteo.discription}
                </Typography>
                <Box>
                    <Grid container>
                        <Grid size={{ xs: 12, md: 9 }}>
                        <Paper
                                sx={{
                                    p: 1,
                                    m: 2,
                                    
                                    maxWidth: '100%',
                                    overflow: 'auto',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                <img
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        maxWidth: 800,
                                        display: 'block'
                                    }}
                                    alt='map'
                                    src={meteo.map?.url ? API_URL + meteo.map.url : img_base}
                                    
                                />
                            </Paper>
                            {/* <Paper sx={{ p: 1, m: 2 }}><img width="800" alt='map' src={meteo.map != null ? API_URL + meteo.map.url : ''}></img></Paper> */}
                        </Grid>
                        <Grid size={{ xs: 12, md: 3 }}>
                            
                            <Paper sx={{ p: 1, m: 2}}><img alt='map_' src={meteo.symbols?.url ? API_URL + meteo.symbols?.url : img_base} style={{width: '100%', height: 'auto',maxWidth: 300, display: 'block'}}></img></Paper>
                            <Paper sx={{ p: 1, m: 2 }}>
                                <List dense='true'>
                                    {meteoList.map((item, index) =>
                                        <ListItem key={index}>
                                            <ListItemButton sx={{ ":hover": { bgcolor: '#E1EEFF' } }} alignItems='center' component="a" href={'/'}>
                                                <ListItemText sx={{ textAlign: 'center' }}>
                                                    {dateFormat(item.meteoDate, 'dd.mm.yyyy hh:mm')}
                                                </ListItemText>
                                            </ListItemButton>
                                        </ListItem>)}
                                </List>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>
                <Typography variant='h5'>{meteo.subtitle}</Typography>
                <Typography className='mainText' component='div'>
                    <Markdown>
                        {meteo.text}
                    </Markdown>
                </Typography>
            </Container>

        </div>
    );
}
export default Meteo;
